import React, { ReactNode } from "react";
import { Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CalendarIcon from "@icons/myicons/calendar-dots.svg?react";
import ChartIcon from "@icons/myicons/chart-line.svg?react";
import TagIcon from "@icons/myicons/tag.svg?react";

const FeatureCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border.secondary}`,
}));

const FeatureIconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "70px",
  borderRadius: "8px",
  backgroundColor: theme.palette.background.info,
  color: theme.palette.primary.main,
}));

const ICON_SIZE = { width: "28px", height: "28px" };

const FEATURES: { icon: ReactNode; labelKey: string }[] = [
  {
    icon: <CalendarIcon {...ICON_SIZE} />,
    labelKey: "premium.featuresModal.features.dividends",
  },
  {
    icon: <ChartIcon {...ICON_SIZE} />,
    labelKey: "premium.featuresModal.features.returns",
  },
  {
    icon: <TagIcon {...ICON_SIZE} />,
    labelKey: "premium.featuresModal.features.classifications",
  },
];

export const FeatureCards = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" }}
      gap={4}
      mb={6}
    >
      {FEATURES.map(({ icon, labelKey }) => (
        <FeatureCard key={labelKey}>
          <FeatureIconBox>{icon}</FeatureIconBox>
          <Typography variant="body1" color="textSecondary" textAlign="center">
            {t(labelKey)}
          </Typography>
        </FeatureCard>
      ))}
    </Box>
  );
};
